import { HIDE_NOTIFICATION, SET_NOTIFICATION } from '../types/types';

export const SetNotificationAction = (payload: any) => {
	return async (dispatch: any) => {
		dispatch({
			type: SET_NOTIFICATION,
			payload: payload
		});
	};
};

export const HideNotificationAction = () => {
	return (dispatch: any) => {
		dispatch({ type: HIDE_NOTIFICATION });
	};
};
